import CreateColumn from '../../../../Services/agGrid/createColumn';
import MultiLineEditor from '../../../../Components/MultiLineEditor/MultiLineEditor';
import { FRadio } from '../../../../Components/MUIs';
import { LEG_BASIC_DEFAULT_LAW_NM } from './LEG_BASIC_Constants';

/**
 * 기본정보 그리드 점검기간: API datetime → YYYY-MM-DD 표시(시간 제거)
 */
const LegBasicGrid1PickDateRaw = (row, keys) => {
  for (let i = 0; i < keys.length; i++) {
    const v = row?.[keys[i]];
    if (v != null && v !== '') return v;
  }
  return '';
};

const LegBasicGrid1ToYmd = (raw) => {
  if (raw == null || raw === '') return '';
  const s = typeof raw === 'string' ? raw : String(raw);
  const t = s.indexOf('T');
  if (t > 0) return s.slice(0, 10);
  const sp = s.indexOf(' ');
  if (sp > 0) return s.slice(0, sp).slice(0, 10);
  return s.length >= 10 ? s.slice(0, 10) : s;
};

const LegBasicGrid1PickLawNm = (row) => {
  for (const key of ['lawNm', 'LAW_NM', 'lwLawNm', 'LW_LAW_NM']) {
    const v = row?.[key];
    if (v != null && v !== '') return String(v);
  }
  return LEG_BASIC_DEFAULT_LAW_NM;
};

/** 법규준수평가 실시 그리드: 신규 필드 + 구 API 필드 병기 */
const LegBasicGrid2Pick = (row, keys) => {
  for (let i = 0; i < keys.length; i++) {
    const v = row?.[keys[i]];
    if (v != null && v !== '') return v;
  }
  return '';
};

const LegBasicGrid2ComplianceDisplay = (row) => {
  const v = LegBasicGrid2Pick(row, [
    'complianceStatus',
    'COMPLIANCE_STATUS',
    'lwCompliance',
    'LW_COMPLIANCE',
  ]);
  if (v === 'Y') return '이행';
  if (v === 'N') return '미이행';
  if (v === '0' || v === 0) return '해당없음';
  return v;
};

/** valueGetter 사용 컬럼: 편집 값을 필드에 확실히 반영(변경 이벤트 누락 방지) */
const LegBasicGrid2StrValueSetter = (field) => (params) => {
  params.data[field] = params.newValue != null ? String(params.newValue) : '';
  return true;
};

/**
 * LEG_BASIC 컬럼 정의 모음
 * - 화면(View)에서는 getColumnDefs*()만 호출해서 사용한다.
 */

export const getColumnDefs1 = (props) => {
  return [
    // NO 컬럼 (체크박스 포함)
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      maxWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef1: props.selectedRowNosRef1,
        lastCheckedIndexRef1: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
    }),

    // 년도/반기/평가기간은 조회 결과 표시용(편집 불가)
    CreateColumn(
      'evalYear',
      '연도',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 140,
      }
    ),
    CreateColumn(
      'evalHalf',
      '상반기/하반기',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 140,
      }
    ),
    CreateColumn(
      'lawNm',
      '법령명',
      'left',
      180,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 160,
        valueGetter: (params) => LegBasicGrid1PickLawNm(params.data),
      }
    ),
    CreateColumn(
      'startDt',
      '점검기간(시작)',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 140,
        valueGetter: (params) =>
          LegBasicGrid1ToYmd(
            LegBasicGrid1PickDateRaw(params.data, [
              'startDt',
              'lwEvaStartDt',
              'START_DT',
            ])
          ),
      }
    ),
    CreateColumn(
      'endDt',
      '점검기간(종료)',
      'center',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 140,
        valueGetter: (params) =>
          LegBasicGrid1ToYmd(
            LegBasicGrid1PickDateRaw(params.data, [
              'endDt',
              'lwEvaEndDt',
              'END_DT',
            ])
          ),
      }
    ),
  ];
};

export const getColumnDefs2 = (props) => {
  const readOnly = !!props.modalReadOnly;

  return [
    // NO 컬럼 (팝업 멀티선택/1클릭 체크 이슈 때문에 공통 GridCheckBox 대신 AG Grid 기본 checkboxSelection 사용)
    {
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      width: 80,
      editable: false,
      headerCheckboxSelection: !readOnly,
      checkboxSelection: !readOnly,
      // 신규행 추가 시 data.no 가 비어있거나(uuid 등) 화면에 "invalid Number"로 보이는 케이스 방지:
      // 표시용 NO는 화면 기준 rowIndex(1부터)로 통일
      valueGetter: (params) =>
        params.node?.rowIndex == null ? '' : params.node.rowIndex + 1,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },

    // TB_BO_COMPLIANCE_EVAL: LW_NM, CHECK_ITEM, CHECK_CONTENT, COMPLIANCE_STATUS, REMARK
    CreateColumn(
      'lwNm',
      '법령명',
      'left',
      180,
      !readOnly,
      true,
      false,
      'text',
      {
        minWidth: 100,
        maxLength: 100,
        cellEditor: 'agTextCellEditor',
        cellEditorParams: { maxLength: 100 },
        valueGetter: (params) =>
          LegBasicGrid2Pick(params.data, ['lwNm', 'LW_NM']),
        valueSetter: LegBasicGrid2StrValueSetter('lwNm'),
      }
    ),

    CreateColumn(
      'checkItem',
      '점검 항목',
      'left',
      220,
      !readOnly,
      true,
      false,
      'text',
      {
        minWidth: 120,
        cellEditor: MultiLineEditor,
        cellEditorParams: { maxLength: 256 },
        valueGetter: (params) =>
          LegBasicGrid2Pick(params.data, [
            'checkItem',
            'CHECK_ITEM',
            'lwProvisions',
            'LW_PROVISIONS',
          ]),
        valueSetter: LegBasicGrid2StrValueSetter('checkItem'),
      }
    ),

    CreateColumn(
      'checkContent',
      '점검 내용',
      'left',
      280,
      !readOnly,
      true,
      false,
      'text',
      {
        flex: 1,
        minWidth: 160,
        cellEditor: MultiLineEditor,
        autoHeight: true,
        suppressKeyboardEvent: (params) => {
          const event = params.event;
          return params.editing && event.ctrlKey && event.key === 'Enter';
        },
        customCellStyle: {
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          whiteSpace: 'pre-line',
        },
        valueGetter: (params) =>
          LegBasicGrid2Pick(params.data, [
            'checkContent',
            'CHECK_CONTENT',
            'lwMain',
            'LW_MAIN',
          ]),
        valueSetter: LegBasicGrid2StrValueSetter('checkContent'),
      }
    ),

    CreateColumn(
      'complianceStatus',
      '이행 여부',
      'center',
      260,
      false,
      false,
      false,
      'text',
      {
        autoHeaderHeight: true,
        wrapHeaderText: true,
        valueGetter: (params) => LegBasicGrid2ComplianceDisplay(params.data),
        cellRenderer: (params) => {
          const HandleChange = (event) => {
            if (readOnly) return;
            params.node.setDataValue('complianceStatus', event);
          };

          return (
            <FRadio
              value={params.value || ''}
              onChange={HandleChange}
              items={[
                { name: '이행', value: '이행', disabled: readOnly },
                { name: '미이행', value: '미이행', disabled: readOnly },
                { name: '해당 없음', value: '해당없음', disabled: readOnly },
              ]}
            />
          );
        },
      }
    ),

    CreateColumn(
      'remark',
      '비고',
      'left',
      200,
      !readOnly,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 120,
        cellEditor: MultiLineEditor,
        valueGetter: (params) =>
          LegBasicGrid2Pick(params.data, [
            'remark',
            'REMARK',
            'lwRemark',
            'LW_REMARK',
          ]),
        valueSetter: LegBasicGrid2StrValueSetter('remark'),
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
  getColumnDefs2,
};

export default columnDefs;
